import { saveAs } from "file-saver";
import { unparse } from "papaparse";

export function createCsv(parsedData, fileName) {
    // Implementation goes here
    const csv = unparse(parsedData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;'});
    saveAs(blob, `${fileName}.csv`);
}

